import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9","key":"svg-0"}],["path",{"d":"M7 20l10 0","key":"svg-1"}],["path",{"d":"M9 16l0 4","key":"svg-2"}],["path",{"d":"M15 16l0 4","key":"svg-3"}],["path",{"d":"M17 4h4v4","key":"svg-4"}],["path",{"d":"M16 9l5 -5","key":"svg-5"}]]

const IconScreenShare = createReactComponent('outline', 'screen-share', 'ScreenShare', __iconNode);

export default IconScreenShare;